import {
  FETCH_LANDMARKS,
  FETCH_LANDMARKS_SUCCESS,
  FETCH_LANDMARKS_FAILED,
} from '../store/types';
import { firebase } from '../config/configureFirebase';
import { get } from 'firebase/database';
import { createIDBCache } from '../other/idbCache';

// Landmarks rarely change (manual admin edits + occasional re-import).
// 24h TTL means each browser fetches the full /landmarks tree at most
// once a day. The dataset is ~5k entries × ~150 bytes = ~750 KB —
// IndexedDB easily fits it (sessionStorage would too in this case, but
// using IDB matches the rest of our caching strategy).
const LANDMARKS_CACHE_TTL_MS = 24 * 60 * 60 * 1000;
const landmarksCache = createIDBCache('donkey_landmarks_cache', 'landmarks', LANDMARKS_CACHE_TTL_MS);
const LANDMARKS_KEY = 'all';

export const fetchLandmarks = () => async (dispatch) => {
  const { landmarksRef } = firebase;

  // Cache hit — instant hydration, no network. Each landmark stays in
  // Redux as { id, name, category, lat, lng, area, ... } for the
  // duration of the session.
  const cached = await landmarksCache.read(LANDMARKS_KEY, 'landmarksCache');
  if (cached) {
    dispatch({ type: FETCH_LANDMARKS_SUCCESS, payload: cached });
    return;
  }

  dispatch({ type: FETCH_LANDMARKS, payload: null });
  try {
    const snap = await get(landmarksRef);
    const data = snap.val();
    if (!data) {
      dispatch({
        type: FETCH_LANDMARKS_SUCCESS,
        payload: [],
      });
      return;
    }
    // Convert the keyed object to an array, preserving the place_id as
    // the entry's `id`. Consumers iterate the array for fuzzy matching.
    const arr = Object.keys(data).map((id) => Object.assign({ id: id }, data[id]));
    await landmarksCache.write(LANDMARKS_KEY, arr, 'landmarksCache');
    dispatch({ type: FETCH_LANDMARKS_SUCCESS, payload: arr });
  } catch (err) {
    dispatch({
      type: FETCH_LANDMARKS_FAILED,
      payload: (err && err.message) || 'Failed to fetch landmarks',
    });
  }
};
